import { addReferenceTitle, referenceListing } from "./referenceListing";
import {
  attachClickAndLongPress,
  createSvgButton,
  getDuplicateRefs,
  icons,
  insertButtonsInWrapper,
  moveRefAfterNextRef,
} from "./RenderButtonLists";

export const RenderButtons = (
  editor,
  setShowFrontMatter,
  setShowReference,
  setShowDuplicate,
  setDuplicateReference
) => {
  if (!editor || !editor.dom) return;

  const dom = editor.dom;
  const body = editor.getBody();

  // Reference elements
  const refs = dom.select("ref");
  const refList = dom.select("ref-list")[0];
  const authorgroup = dom.select("contrib-group");
  const keywordgroup = dom.select("kwd-group");
  const authorNotes = dom.select("author-notes");
  const section = dom.select("sec");

  let refListTitle;
  if (refList) {
    refList.setAttribute("contenteditable", "true");
    refList.setAttribute("data-lock", "true");
    refList.setAttribute("draggable", "false"); // Prevent drag
    refListTitle = refList.querySelector("title1");
  }

  if (refListTitle) {
    if (!refList.querySelector("[data-edit='refTitleWrapper']")) {
      const wrapperDiv = document.createElement("div");
      wrapperDiv.setAttribute("data-edit", "refTitleWrapper");
      wrapperDiv.setAttribute("contenteditable", "true");
      wrapperDiv.setAttribute("data-lock", "true");
      editor.dom.insertAfter(wrapperDiv, refListTitle);
      wrapperDiv.appendChild(refListTitle);

      const duplicateBtn = createSvgButton(editor, {
        type: "refDublicate",
        edit: "duplicate",
        svg: "Find Duplicate",
      });
      wrapperDiv.appendChild(duplicateBtn);
      // No direct listener here, handled by event delegation
    }
  }

  if (refs) {
    refs.forEach((ref) => {
      const childNode = ref.querySelector("mixed-citation");
      const reftitle = ref.querySelector("reference-text");
      const refHead = ref.querySelector("reftitle");
      ref.setAttribute("data-lock", "true");
      ref.setAttribute("contenteditable", "true");

      // Create buttons
      const ToggleButton = createSvgButton(editor, {
        type: "refbtn",
        edit: "edit",
        svg: icons.toggle,
      });

      const editButton = createSvgButton(editor, {
        type: "refEdit",
        edit: "edit",
        svg: icons.edit,
      });

      const addButton = createSvgButton(editor, {
        type: "refAdd",
        edit: "add",
        svg: icons.add,
      });

      const deleteButton = createSvgButton(editor, {
        type: "refDelete",
        edit: "delete",
        svg: icons.delete,
      });

      const swapButton = createSvgButton(editor, {
        type: "refSwap",
        edit: "swap",
        svg: icons.switch,
      });

      const moveButton = createSvgButton(editor, {
        type: "refSwap",
        edit: "move",
        svg: icons.move,
      });

      if (
        reftitle &&
        !reftitle.parentNode.querySelector('[data-btn-type = "refbtn"]')
      ) {
        reftitle.setAttribute("contenteditable", "true");
        reftitle.setAttribute("data-lock", "true");

        if (ToggleButton) {
          editor.dom.add(reftitle, ToggleButton);

          if (childNode) {
            childNode.setAttribute("contenteditable", "true");
            childNode.setAttribute("data-lock", "true");

            editor.dom.setStyle(
              childNode,
              "transition",
              "opacity 0.3s ease, visibility 0.3s ease"
            );
            editor.dom.setStyle(childNode, "opacity", "0");
            editor.dom.setStyle(childNode, "visibility", "hidden");
            editor.dom.setStyle(childNode, "display", "none");

            editor.dom.setAttrib(childNode, "data-hidden", "true");

            // ToggleButton click handled in event delegation
          }
        }
      }

      // if (refHead && !refHead.querySelector('[data-edit = "refWrapper"]')) {
      //   insertButtonsInWrapper(
      //     refHead,
      //     swapButton,
      //     moveButton,
      //     editButton,
      //     addButton,
      //     deleteButton
      //   );
      // } else {
      //   // Observe ref until reftitle (refHead) is added
      //   const observer = new MutationObserver((mutationsList, obs) => {
      //     for (const mutation of mutationsList) {
      //       for (const addedNode of mutation.addedNodes) {
      //         if (
      //           addedNode.nodeType === 1 &&
      //           addedNode.nodeName.toLowerCase() === "reftitle"
      //         ) {
      //           obs.disconnect();
      //           if (
      //             refHead &&
      //             !refHead.querySelector('[data-edit = "refWrapper"]')
      //           ) {
      //             insertButtonsInWrapper(
      //               refHead,
      //               swapButton,
      //               moveButton,
      //               editButton,
      //               addButton,
      //               deleteButton
      //             );
      //           }
      //         }
      //       }
      //     }
      //   });

      //   observer.observe(ref, {
      //     childList: true,
      //     subtree: true,
      //   });
      // }
      const addButtonsWhenReady = () => {
        const interval = setInterval(() => {
          if (!ref) return;

          const refHeadFound = ref.querySelector("reftitle");
          if (!refHeadFound) return;

          if (!refHeadFound.querySelector('[data-edit="refWrapper"]')) {
            insertButtonsInWrapper(
              editor,
              refHeadFound,
              swapButton,
              moveButton,
              editButton,
              addButton,
              deleteButton
            );
          }

          clearInterval(interval);
        }, 50);
      };
      //       const addButtonsWhenReady = () => {
      //   if (!ref) return;

      //   const observer = new MutationObserver(() => {
      //     const refHeadFound = ref.querySelector("reftitle");
      //     if (!refHeadFound) return;

      //     if (!refHeadFound.querySelector('[data-edit="refWrapper"]')) {
      //       insertButtonsInWrapper(editor,
      //         "reftitle",
      //         swapButton,
      //         moveButton,
      //         editButton,
      //         addButton,
      //         deleteButton
      //       );
      //       observer.disconnect(); // stop observing once done
      //     }
      //   });

      //   observer.observe(ref, { childList: true, subtree: true });
      // };

      addButtonsWhenReady();
    });
  }

  // Front Matter Buttons
  if (authorgroup && authorgroup.length > 0) {
    const contribGroup = authorgroup[0];
    const contrib = contribGroup.querySelector("contrib");
    const aff = contribGroup.querySelector("aff");

    let button;
    let affbutton;

    if (
      contrib &&
      !contribGroup.querySelector('[data-btn-type="authorgroupedit"]')
    ) {
      button = editor.dom.create(
        "button",
        {
          type: "button",
          "data-btn-type": "authorgroupedit",
          "data-edit": "edit",
        },
        `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
      viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
      class="icon icon-tabler icons-tabler-outline icon-tabler-edit">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"/>
      <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"/>
      <path d="M16 5l3 3"/>
    </svg>`
      );

      contribGroup.insertBefore(button, contrib);
    }

    if (
      aff &&
      !contribGroup.querySelector('[data-btn-type="affiliationedit"]')
    ) {
      affbutton = editor.dom.create(
        "button",
        {
          type: "button",
          "data-btn-type": "affiliationedit",
          "data-edit": "edit",
        },
        `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
      viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
      class="icon icon-tabler icons-tabler-outline icon-tabler-edit">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"/>
      <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"/>
      <path d="M16 5l3 3"/>
    </svg>`
      );

      aff.appendChild(affbutton);
    }
  }

  // Keywords
  if (keywordgroup && keywordgroup.length > 0) {
    const keywordchild = keywordgroup[0];
    const keywords = keywordchild.querySelector("kwd");

    if (
      keywords &&
      !keywordchild.querySelector('[data-btn-type="keywordedit"]')
    ) {
      const keybutton = editor.dom.create(
        "button",
        {
          type: "button",
          "data-btn-type": "keywordedit",
        },
        `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
      viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
      class="icon icon-tabler icons-tabler-outline icon-tabler-edit">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"/>
      <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"/>
      <path d="M16 5l3 3"/>
    </svg>`
      );

      keywordchild.insertBefore(keybutton, keywords);
    }
  }

  // Author notes contenteditable
  if (authorNotes[0]) {
    authorNotes.forEach((item) => {
      const label = item.querySelector("corresp");
      label.setAttribute("data-lock", "true");
      label.setAttribute("contenteditable", "true");
    });
  }

  // EVENT DELEGATION FOR BUTTON CLICKS
  if (body) {
    body.removeEventListener("click", delegatedClickHandler);
    body.addEventListener("click", delegatedClickHandler);
  }

  function delegatedClickHandler(e) {
    const button = e.target.closest("button[data-btn-type]");
    if (!button) return;

    const btnType = button.getAttribute("data-btn-type");
    const editType = button.getAttribute("data-edit");
    const ref = button.closest("ref");
    const refId = ref ? ref.getAttribute("id") : null;

    switch (btnType) {
      case "refEdit":
        setShowReference((prev) => ({
          ...prev,
          edit: { open: true, id: refId },
        }));
        break;

      case "refAdd":
        setShowReference((prev) => ({
          ...prev,
          add: { open: true, id: refId },
        }));
        break;

      case "refDelete":
        setShowReference((prev) => ({
          ...prev,
          delete: { open: true, id: refId },
        }));
        break;

      case "refSwap":
        if (editType === "swap") {
          moveRefAfterNextRef(editor, button, setShowReference);
        } else if (editType === "move") {
          setShowReference((prev) => ({
            ...prev,
            swap: { open: false, edit: true, id: refId },
          }));
        }
        break;

      case "refDublicate":
        const duplicates = getDuplicateRefs(editor);
        setShowDuplicate(true);
        setDuplicateReference(duplicates);
        break;

      case "authorgroupedit":
        setShowFrontMatter({ authorgrouping: true });
        break;

      case "affiliationedit":
        setShowFrontMatter({ affiliation: true });
        break;

      case "keywordedit":
        setShowFrontMatter({ keywords: true });
        break;

      case "refbtn": {
        if (!ref) return;

        const childNode = ref.querySelector("mixed-citation");
        if (!childNode) return;

        const ToggleButton = ref.querySelector("button");
        if (!ToggleButton) return;

        if (ToggleButton._isToggling) return;
        ToggleButton._isToggling = true;

        if (!childNode.hasAttribute("data-initialized")) {
          childNode.setAttribute("contenteditable", "true");
          childNode.setAttribute("data-lock", "true");

          editor.dom.setStyle(
            childNode,
            "transition",
            "opacity 0.3s ease, visibility 0.3s ease"
          );
          editor.dom.setStyle(childNode, "opacity", "0");
          editor.dom.setStyle(childNode, "visibility", "hidden");
          editor.dom.setStyle(childNode, "display", "none");

          editor.dom.setAttrib(childNode, "data-hidden", "true");

          childNode.setAttribute("data-initialized", "true");
        }

        const isHidden =
          editor.dom.getAttrib(childNode, "data-hidden") === "true";

        if (isHidden) {
          // Show element
          editor.dom.setAttrib(childNode, "data-hidden", "false");
          editor.dom.setStyle(childNode, "display", "block");
          editor.dom.setStyle(ToggleButton, "transform", "rotate(180deg)");

          // Wait a frame so display:block applies before opacity change
          requestAnimationFrame(() => {
            editor.dom.setStyle(childNode, "opacity", "1");
            editor.dom.setStyle(childNode, "visibility", "visible");

            // Unlock toggle after transition duration
            setTimeout(() => {
              ToggleButton._isToggling = false;
            }, 310);
          });
        } else {
          editor.dom.setStyle(childNode, "opacity", "0");
          editor.dom.setStyle(childNode, "visibility", "hidden");
          editor.dom.setStyle(ToggleButton, "transform", "rotate(0deg)");

          const onTransitionEnd = (e) => {
            if (e.propertyName === "opacity") {
              editor.dom.setStyle(childNode, "display", "none");
              editor.dom.setAttrib(childNode, "data-hidden", "true");
              ToggleButton._isToggling = false;
              childNode.removeEventListener("transitionend", onTransitionEnd);
            }
          };
          childNode.addEventListener("transitionend", onTransitionEnd);
        }

        break;
      }

      default:
        break;
    }
  }

  // if(section.length){
  //   console.log(section,"section");

  //   section.forEach((item)=>{
  //     const label=item.querySelector("label")
  //      label.setAttribute("data-lock", "true");
  //     label.setAttribute("contenteditable", "true");
  //   })
  // }
};
